import { useStyles } from "@/styles/useStyles";
import { Group, Text, Space, Progress } from "@mantine/core";
import { IconClock } from "@tabler/icons-react";

export function AssignmentItemTimeProgress({
  totalSecondsWatched,
  totalSecondsRequired,
  isSmall = false,
}: {
  totalSecondsWatched: number;
  totalSecondsRequired: number;
  isSmall?: boolean;
}) {
  const { theme } = useStyles();
  return (
    <Group
      w="100%"
      justify="center"
      align="center"
      flex={1}
      // pl={0}
      // pr="md"
      // pt={4}
      gap={4}
    >
      <IconClock
        size={isSmall ? 12 : 16}
        style={{ color: theme.colors.text[7] }}
      />
      <Text lh={1.2} c="text.7" size={isSmall ? "xs" : "sm"}>
        {Math.floor(totalSecondsWatched / 60)
          .toString()
          .padStart(1, "0")}
        :{(totalSecondsWatched % 60).toFixed(0).padStart(2, "0")}
      </Text>
      <Space w={8} />
      <Progress
        value={(totalSecondsWatched / totalSecondsRequired) * 100}
        color="primary.7"
        flex={1}
        size={isSmall ? "sm" : "md"}
        transitionDuration={1000}
      />
      <Space w={8} />
      <Text lh={1.2} c="text.7" size={isSmall ? "xs" : "sm"}>
        {Math.floor(totalSecondsRequired / 60)
          .toString()
          .padStart(1, "0")}
        :{(totalSecondsRequired % 60).toString().padStart(2, "0")}
      </Text>
    </Group>
  );
}
